import { ref } from "vue";
const commonKey = ref(false);
export const useCommonKey = () => {
    return {
        commonKey,
    }

}